import * as domain from '../../data/domain';

export const AIRWALLEX_INTEGRATION_CODES = [domain.IntegrationCode.XeroAirwallexBatchPayment];
export const CONNECT_TO_AIRWALLEX_LEARN_MORE_LINK =
    'https://support.approvalmax.com/portal/en/kb/articles/how-to-connect-approvalmax-to-airwallex';
